import moment from "moment";
import { Alert, Button, Card, Col, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";

function StatusCita({t, text, helpCenter, doctor, cita}){

    return (
        <Row>
            <Col xs="12" md={{span: 4, offset: 4}}>
                <Card>
                    <Card.Body className="text-center">
                        {text}
                        {doctor && 
                        <h6>
                            {`${moment(cita.scheduleDTO.dateTimeInit, 'YYYY-MM-DDTHH:mm:ss').format("DD-MM-YYYY HH:mm")}`} <br />
                            {`${cita?.patientDTO?.name} ${cita?.patientDTO?.middleName ?? ''} ${cita?.patientDTO?.lastName} ${cita?.patientDTO?.seccondSurname ?? ''}`}
                        </h6>}
                        <Button variant="link" block onClick={() => window.location.reload()}>Volver a intentar</Button>
                        {
                            helpCenter &&
                            <Alert className="p-1" variant="light">
                                <span className="font-size-09rem text-secondary font-weight-bold">
                                    {helpCenter}
                                </span>
                            </Alert>
                        }
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default withTranslation()(StatusCita)